/**
 *
 *
 *
 *
 *
 *
 *
 */
export const FASHION_ASSORTMENTS = ['Bekleidung', 'Schuhe', 'Wäsche'] as const;
export const FASHION_ASSORTMENTS_SET = new Set(FASHION_ASSORTMENTS.map((item) => item.toLowerCase()));
